const {orders} = require("~/router/private/order")
const {incoming} = require("~/router/private/incoming")
const {realization} = require("~/router/private/realization")
const {report} = require("~/router/private/report_ongoing")
const {carPark} = require("~/router/private/drivers_fleet")

export const main = [
    ...orders,
    ...incoming,
    ...realization,
    ...report,
    ...carPark
]
